import { Component, OnInit } from '@angular/core';
import { NavService } from '../../services/nav.service';

@Component({
  selector: 'app-timezone-clock-modal',
  templateUrl: './timezone-clock-modal.component.html',
  styleUrl: './timezone-clock-modal.component.scss',
})
export class TimezoneClockModalComponent implements OnInit {
  constructor(public navService: NavService) {}

  ngOnInit(): void {}
}
